import React from 'react';
import styled from 'styled-components';
import { SectionParent, H1, H2, B1, BlueButton } from '../../StyledComponents';
import { navigate } from '@reach/router';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Education from '../../../assets/v2/Hardware/Carousel/education.svg';
import Retail from '../../../assets/v2/Hardware/Carousel/retail.svg';
import Health from '../../../assets/v2/Hardware/Carousel/health.svg';
import Logistics from '../../../assets/v2/Hardware/Carousel/logistics.svg';
import RetailDevice from '../../../assets/v2/Hardware/Carousel/RetailDevice.png';
import LogisticsDevice from '../../../assets/v2/Hardware/Carousel/LogisticsDevice.png';
import HealthDevice from '../../../assets/v2/Hardware/Carousel/HealthDevice.png';
import EducationDevice from '../../../assets/v2/Hardware/Carousel/EducationDevice.png';
import WishtelDevice from '../../../assets/v2/Hardware/Carousel/wishtel.png';
import LenovoLogo from '../../../assets/v2/Hardware/Carousel/LenovoLogo.png';
import iraLogo from '../../../assets/v2/Hardware/Carousel/iraLogo.svg';
import PosLogo from '../../../assets/v2/Hardware/Carousel/PosLogo.png';
import ZebraLogo from '../../../assets/v2/Hardware/Carousel/ZebraLogo.png';
import NokiaLogo from '../../../assets/v2/Hardware/Carousel/NokiaLogo.png';
import DotGrey from '../../../assets/v2/Hardware/Carousel/DotGrey.svg';
import DotGreen from '../../../assets/v2/Hardware/Carousel/DotGreen.svg';
import Slide from 'react-reveal/Slide';
import Fade from 'react-reveal/Fade';

const LazyImg = styled(LazyLoadImage)`
  height: 100%;
  width: auto;
  max-width: 100%;
  max-height: 100%;
`;

const Section = styled(SectionParent)`
  display: grid;
  justify-items: center;
  width: 100%;
  min-height: 100vh;
  align-content: center;
  padding-bottom: 5rem !important;
  padding-top: 5rem !important;
  background-color: #f9fbfe;
`;

const SectionHeading = styled.div`
  font-size: 36px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  opacity: 0.9;
  padding-bottom: 3rem;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const DotContainer = styled.div`
  display: grid;
  grid-column: span 1;
  align-content: center;
  justify-content: center;
  min-height: 40rem;
  @media (max-width: 800px) {
    display: none;
  }
`;

const DotContainerMobile = styled(DotContainer)`
  display: none;
  @media (max-width: 800px) {
    display: grid;
  }
  grid-column: span 4;
  grid-template-columns: repeat(4, 1fr);
  min-height: unset;
  width: 70%;
  justify-self: center;
  padding-top: 3rem;
`;

const Dot = styled.img`
  padding-bottom: 1rem;
  cursor: pointer;
  justify-self: center;
  @media (max-width: 800px) {
    display: none;
  }
`;
const DotMobile = styled(Dot)`
  display: none;
  @media (max-width: 800px) {
    display: grid;
  }
  grid-column: span 1;
`;

const ExplanationContainer = styled.div`
  display: grid;
  grid-column: span 1;
  grid-column: span 1;
  align-content: center;
  justify-content: center;
  min-height: 300px;
  animation-name: Explain;
  animation-duration: 1s;
  @keyframes Explain {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @media (max-width: 800px) {
    grid-column: span 4;
  }
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 1.5rem;
  @media (max-width: 800px) {
    justify-content: center;
  }
`;

const Title = styled.div`
  font-size: 48px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.6;
  letter-spacing: normal;
  color: #5cbd9a;
`;

const TitleImage = styled(LazyLoadImage)`
  width: 80px;
  height: 79px;
  padding-right: 1rem;
`;

const UseCase = styled.div`
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  opacity: 0.52;
  @media (max-width: 800px) {
    text-align: center;
  }
`;

const UseCaseText = styled.div`
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #151828;
  padding-bottom: 1.5rem;
  @media (max-width: 800px) {
    text-align: center;
  }
`;
const LogoWrapper = styled.div`
  display: grid;
  justify-items: start;
  @media (max-width: 800px) {
    justify-items: center;
  }
`;

const LogoImage = styled(LazyLoadImage)`
  /* max-width: 153px; */
  height: 31px;
  margin-top: 0.5rem;
`;

const DeviceContainer = styled.div`
  display: grid;
  grid-column: span 2;
  justify-items: center;
  align-items: center;
  min-height: 400px;
  animation-name: ExplainDevice;
  animation-duration: 1s;
  @keyframes ExplainDevice {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @media (max-width: 800px) {
    grid-column: span 4;
  }
`;

const DeviceName = styled.div`
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.58;
  letter-spacing: normal;
  color: #151828;
`;

const DeviceImage = styled(LazyLoadImage)`
  width: fit-content;
  height: fit-content;
  padding-bottom: 2rem;
  @media (max-width: 800px) {
    width: 100%;
    height: 100%;
    padding: 0 2rem;
  }
`;

const DetailsArray = [
  {
    purpose: 'Education',
    purposeImage: Education,
    UseCase: 'Student Tablet',
    oem: iraLogo,
    deviceName: 'Wishtel 102017i',
    deviceLogo: WishtelDevice,
    link: 'wishtel-ira-102017i',
  },
  {
    purpose: 'Retail',
    purposeImage: Retail,
    UseCase: 'Self-Service Checkout',
    oem: PosLogo,
    deviceName: 'Bigpos',
    deviceLogo: RetailDevice,
    link: 'posbank-bigpos',
  },
  {
    purpose: 'Healthcare',
    purposeImage: Health,
    UseCase: 'Clinical-Grade Remote Monitoring',
    oem: NokiaLogo,
    deviceName: 'Nokia 8.1',
    deviceLogo: HealthDevice,
    link: 'nokia-22',
  },
  {
    purpose: 'Logistics',
    purposeImage: Logistics,
    UseCase: 'Warehouse scanning',
    oem: ZebraLogo,
    deviceName: 'Zebra',
    deviceLogo: LogisticsDevice,
    link: 'zebra-tc70x',
  },
];

export default class HardwareCarousel extends React.Component<any, any> {
  private timer: any;
  isCMounted = false;
  constructor(props: any) {
    super(props);
    this.state = {
      counter: 0,
      mobile: false,
      inView: false,
    };
  }

  componentDidMount() {
    this.isCMounted = true;
    // this.timer = setTimeout(this.counterInreaser, 10000);
    window.addEventListener('resize', this.resize);
    window.addEventListener('scroll', this.onScroll);
    this.resize();
  }

  onScroll = () => {
    const header = document.getElementById('hardware-carousel');

    if (this.state.inView === false && header && this.isCMounted) {
      // Get the offset position of the navbar
      const containerTop = header!.offsetTop;
      const currentTopPosition = window.pageYOffset;
      if (currentTopPosition > containerTop) {
        this.setState({ inView: true }, () => {
          this.timer = setTimeout(this.counterInreaser, 10000);
        });
      }
    }
  };
  counterInreaser = (counter?: number) => {
    clearTimeout(this.timer);
    if (counter === undefined) {
      if (this.state.counter === 3) {
        this.setState((state: any) => ({
          counter: 0,
        }));
      } else {
        this.setState((state: any) => ({
          counter: state.counter === 0 ? 1 : state.counter + 1,
        }));
      }
    } else {
      this.setState((state: any) => ({
        counter,
      }));
    }
    this.timer = setTimeout(this.counterInreaser, 10000);
  };
  componentWillUnmount() {
    this.isCMounted = false;
    window.removeEventListener('scroll', this.onScroll);
    clearTimeout(this.timer);
  }
  resize = () => {
    if (window.innerWidth <= 800) {
      this.setState({ mobile: true });
    } else {
      this.setState({ mobile: false });
    }
  };
  render() {
    return (
      <Section
        id="hardware-carousel"
        style={{
          backgroundColor: this.props.partnerPage ? '#ffffff' : '#f9fbfe',
        }}
      >
        <SectionHeading>Featured Devices</SectionHeading>
        <GridContainer>
          <DotContainer>
            <Dot
              src={this.state.counter === 0 ? DotGreen : DotGrey}
              onClick={() => this.setState({ counter: 0 })}
            />
            <Dot
              src={this.state.counter === 1 ? DotGreen : DotGrey}
              onClick={() => this.setState({ counter: 1 })}
            />
            <Dot
              src={this.state.counter === 2 ? DotGreen : DotGrey}
              onClick={() => this.setState({ counter: 2 })}
            />
            <Dot
              src={this.state.counter === 3 ? DotGreen : DotGrey}
              onClick={() => this.setState({ counter: 3 })}
            />
          </DotContainer>
          <ExplanationContainer
            key={`explain1${this.state.counter}`}
            id={`explanation${this.state.counter}`}
          >
            <Fade
              key={`explain2${this.state.counter}`}
              id={`explanation${this.state.counter}`}
              // bottom={!this.state.mobile}
              // left={this.state.mobile}
            >
              <TitleSection>
                <TitleImage
                  src={DetailsArray[this.state.counter].purposeImage}
                />
                <Title>{DetailsArray[this.state.counter].purpose}</Title>
              </TitleSection>
            </Fade>
            <Fade
              key={`explain3${this.state.counter}`}
              id={`explanation${this.state.counter}`}
              // bottom={!this.state.mobile}
              // left={this.state.mobile}
            >
              <UseCase>USE CASE</UseCase>
            </Fade>
            <Fade
              key={`explain4${this.state.counter}`}
              id={`explanation${this.state.counter}`}
              // bottom={!this.state.mobile}
              // left={this.state.mobile}
            >
              <UseCaseText>
                {DetailsArray[this.state.counter].UseCase}
              </UseCaseText>{' '}
            </Fade>
            <Fade
              key={`explain5${this.state.counter}`}
              id={`explanation${this.state.counter}`}
              // bottom={!this.state.mobile}
              // left={this.state.mobile}
            >
              <UseCase>OEM</UseCase>{' '}
            </Fade>
            <Fade
              key={`explain6${this.state.counter}`}
              id={`explanation${this.state.counter}`}
              // bottom={!this.state.mobile}
              // left={this.state.mobile}
            >
              <LogoWrapper>
                <LogoImage src={DetailsArray[this.state.counter].oem} />{' '}
              </LogoWrapper>
            </Fade>
          </ExplanationContainer>
          <DeviceContainer
            key={`devices1${this.state.counter}`}
            id={`device-1${this.state.counter}`}
          >
            <Slide
              key={`devices2${this.state.counter}`}
              id={`device-2${this.state.counter}`}
              bottom={!this.state.mobile}
              left={this.state.mobile}
            >
              <DeviceName>
                {DetailsArray[this.state.counter].deviceName}
              </DeviceName>
            </Slide>
            <Slide
              key={`devices3${this.state.counter}`}
              id={`device-3${this.state.counter}`}
              bottom={!this.state.mobile}
              left={this.state.mobile}
            >
              <DeviceImage src={DetailsArray[this.state.counter].deviceLogo} />
            </Slide>
            <BlueButton
              onClick={() =>
                navigate(`/${DetailsArray[this.state.counter].link}`)
              }
            >
              Know More
            </BlueButton>
          </DeviceContainer>
          <DotContainerMobile>
            <DotMobile
              src={this.state.counter === 0 ? DotGreen : DotGrey}
              onClick={() => this.counterInreaser(0)}
            />
            <DotMobile
              src={this.state.counter === 1 ? DotGreen : DotGrey}
              onClick={() => this.counterInreaser(1)}
            />
            <DotMobile
              src={this.state.counter === 2 ? DotGreen : DotGrey}
              onClick={() => this.counterInreaser(2)}
            />
            <DotMobile
              src={this.state.counter === 3 ? DotGreen : DotGrey}
              onClick={() => this.counterInreaser(3)}
            />
          </DotContainerMobile>
        </GridContainer>
      </Section>
    );
  }
}
